export default __webpack_public_path__ + "static/media/logo.6ce17511.svg";